import React, { useEffect, useCallback, useState } from "react";
import Layout from "../../Components/Layout";
import { Icon } from "@iconify/react";
import "../../Assets/CSS/Employeemanagement.css";
import AddEmployeeModel from "../../Components/common/AddEmployeeModel";
import "../../Components/common/AddEmployeeModel.css";
import axios from "axios";
import { btnfont, DarkBold, LighterBold, Lightly } from "../../Assets/CSS/Text";
import EditModel from "../../Components/Model/EditModel";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Newbtn } from "../../Assets/CSS/Button";

// import AddEmployeeModal from "../Components/Modals/AddEmployeeModal";

const EmployeeManagement = () => {
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [employee, setEmployees] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize] = useState(10);
  // const [totalPages, setTotalPages] = useState(1);
  // const [totalElements, setTotalElements] = useState(0);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [loading, setLoading] = useState(true);

  const toggleMenu = (empId) => {
    setActiveDropdown((prev) => (prev === empId ? null : empId));
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());
  const featchEmployeeData = useCallback(async () => {
    setLoading(true); // Start loading before fetching
    try {
      const token = localStorage.getItem("token"); // Or however you're storing it
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          // params: {
          //   page: pageNumber,
          //   size: pageSize,
          // },
        },
      );

      console.log("Employee API response:", response.data);
      setEmployees(response.data.content || []);
      // setTotalPages(response.data.totalPages ?? 1);
      // setTotalElements(
      //   response.data.totalElements ?? response.data.content?.length ?? 0,
      // );
    } catch (error) {
      console.error("Error fetching employee data:", error);
    } finally {
      setLoading(false); // Stop loading after fetch
    }
  }, [pageNumber, pageSize]);

  useEffect(() => {
    featchEmployeeData();
  }, [featchEmployeeData]);
  // const handleEditClick = (emp, showEditModal) => {
  //   setSelectedEmployee(emp, showEditModal);
  //   console.log("Employee data", emp);
  //   setShowEditModal(true);
  // };
  const handleEditClick = (emp, showEditModal) => {
    // Remove +91 from mobile number if present
    const cleanedMobile = emp.mobileNumber?.startsWith("+91")
      ? emp.mobileNumber.slice(3)
      : (emp.mobileNumber ?? "");

    // Store cleaned data for editing
    const updatedEmp = {
      ...emp,
      mobileNumber: cleanedMobile,
    };

    setSelectedEmployee(updatedEmp);
    console.log("Employee data (cleaned for editing):", updatedEmp);
    setShowEditModal(true);
  };

  // const handleCloseModal = () => {
  //   console.log("Closing modal");
  //   setShowEditModal(false);
  //   setShowModal(false);
  // };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleClose = () => {
    setShowEditModal(false);
  };

  const goToPage = (page) => {
    if (page < 0 || page >= filteredTotalPages) return;
    setPageNumber(page);
  };

  const handlePrevPage = () => {
    goToPage(pageNumber - 1);
  };

  const handleNextPage = () => {
    goToPage(pageNumber + 1);
  };
  // const handleSave = async (updatedData) => {

  //   try {
  //     console.log("updated data ", updatedData);
  //     // 🔍 Mobile number validation: must be at least 10 digits (handle formats like "+91 9876543210" or "9876543210")
  //     const cleanMobile = updatedData.mobileNumber?.replace(/\D/g, '') || '';
  //     const mobilePattern = /^[0-9]{10,12}$/;
  //     if (!mobilePattern.test(cleanMobile)) {
  //       toast.error("Mobile number must be 10-12 digits.");
  //       return;
  //     }
  //     // 📧 Personal Email must be Gmail
  //     const personalEmailPattern =
  //       /^(?!.*\.\.)(?!\.)[a-zA-Z0-9._]{2,}(?<!\.)@gmail\.com$/;

  //     if (!personalEmailPattern.test(updatedData.personalEmail)) {
  //       toast.error("Invalid Gmail format. ");
  //       return;
  //     }

  //     // 🔤 Text-only fields (no numbers/special chars)
  //     const textOnly = /^[A-Za-z\s]{1,25}$/;
  //     const invalidTextFields = [
  //       "firstName",
  //       "lastName",
  //       "designation",
  //       "departmentName",
  //     ].filter((field) => !textOnly.test(updatedData[field]));
  //     if (invalidTextFields.length > 0) {
  //       toast.error(
  //         "Name, Designation and Department must contain only letters and be under 25 characters."
  //       );
  //       return;
  //     }

  //     // 🎂 DOB must imply age ≥ 18
  //     const birthDate = new Date(updatedData.dateOfBirth);
  //     const today = new Date();
  //     const minDate = new Date(
  //       today.getFullYear() - 18,
  //       today.getMonth(),
  //       today.getDate()
  //     );
  //     if (birthDate > minDate) {
  //       toast.error("Candidate must be at least 18 years old.");
  //       return;
  //     }

  //     // 📊 Leaves must not exceed 50 per category
  //     const maxLeave = 50;
  //     if (
  //       updatedData.totalAllocatedSickLeave > maxLeave ||
  //       updatedData.totalAllocatedCasualLeave > maxLeave ||
  //       updatedData.totalAllocatedEarnedLeave > maxLeave
  //     ) {
  //       toast.error("Allocated leaves cannot exceed 50 in any category.");
  //       return;
  //     }
  //     const token = localStorage.getItem("token");
  //      // ✅ ✅ ✅ ONLY CHANGED PAYLOAD
  //     const changedPayload = getChangedFields(selectedEmployee, updatedData);

  //     // ✅ ensure role stays array
  //     if (changedPayload.role) {
  //       changedPayload.role = [changedPayload.role];
  //     }
  //     const response = await axios.patch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/${selectedEmployee.empId}`, // ✅ Updated API URL
  //     changedPayload, // ✅ Send only changed fields
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("Update success", response.data);
  //     toast.success("Employee updated successfully!");
  //     setShowEditModal(false);
  //     featchEmployeeData(); // 🔁 Refresh data after update
  //   } catch (error) {
  //     console.error("Error updating employee:", error);
  //     alert("Failed to update employee");
  //   }
  // };
  // const handleSave = async (updatedData) => {
  //   try {
  //     console.log("Updated data:", updatedData);

  //     // 🔍 Mobile number validation (accepts +91 or without)
  //     const cleanMobile = updatedData.mobileNumber?.replace(/\D/g, '') || '';
  //     const mobilePattern = /^[0-9]{10}$/; // Strict 10 digits only
  //     if (!mobilePattern.test(cleanMobile)) {
  //       toast.error("Mobile number must be 10 digits (Indian format).");
  //       return;
  //     }

  //     // 📧 Validate Gmail address
  //     const personalEmailPattern =
  //       /^(?!.*\.\.)(?!\.)[a-zA-Z0-9._]{2,}(?<!\.)@gmail\.com$/;
  //     if (!personalEmailPattern.test(updatedData.personalEmail)) {
  //       toast.error("Invalid Gmail format.");
  //       return;
  //     }

  //     // 🔤 Text-only fields validation
  //     const textOnly = /^[A-Za-z\s]{1,25}$/;
  //     const invalidTextFields = ["firstName", "lastName", "designation", "departmentName"]
  //       .filter((field) => !textOnly.test(updatedData[field]));
  //     if (invalidTextFields.length > 0) {
  //       toast.error("Name, Designation, and Department must contain only letters (max 25 chars).");
  //       return;
  //     }

  //     // 🎂 Age validation (must be ≥18)
  //     const birthDate = new Date(updatedData.dateOfBirth);
  //     const today = new Date();
  //     const minDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  //     if (birthDate > minDate) {
  //       toast.error("Candidate must be at least 18 years old.");
  //       return;
  //     }

  //     // 📊 Leave validation
  //     const maxLeave = 50;
  //     if (
  //       updatedData.totalAllocatedSickLeave > maxLeave ||
  //       updatedData.totalAllocatedCasualLeave > maxLeave ||
  //       updatedData.totalAllocatedEarnedLeave > maxLeave
  //     ) {
  //       toast.error("Allocated leaves cannot exceed 50 per category.");
  //       return;
  //     }

  //     const token = localStorage.getItem("token");

  //     // 🟡 Get only changed fields
  //     const changedPayload = getChangedFields(selectedEmployee, updatedData);

  //     // 🟢 Always include countryCode and formatted mobile number
  //     changedPayload.countryCode = "+91";
  //     if (changedPayload.mobileNumber || updatedData.mobileNumber) {
  //       changedPayload.mobileNumber = cleanMobile; // ensure only digits
  //     }

  //     // 🟢 Ensure role is an array if changed
  //     if (changedPayload.role) {
  //       changedPayload.role = [changedPayload.role];
  //     }

  //     console.log("📦 Final PATCH payload:", changedPayload);

  //     // 🔗 API call
  //     const response = await axios.patch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/${selectedEmployee.empId}`,
  //       changedPayload,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("✅ Update success:", response.data);
  //     toast.success("Employee updated successfully!");
  //     setShowEditModal(false);
  //     featchEmployeeData(); // Refresh list
  //   } catch (error) {
  //     console.error("❌ Error updating employee:", error);
  //     toast.error("Failed to update employee.");
  //   }
  // };

  // this send only specific data which are changed by user and also added validation for mobile number, email, text only field, age and leave validation. It also handle the country code and mobile number format in a better way.

  // const handleSave = async (updatedData) => {
  //   try {
  //     console.log("Updated data:", updatedData);

  //     // 🔍 Mobile number validation (accepts +91 or without)
  //     const cleanMobile = updatedData.mobileNumber?.replace(/\D/g, '') || '';
  //     const mobilePattern = /^[0-9]{10}$/; // Strict 10 digits only
  //     if (!mobilePattern.test(cleanMobile)) {
  //       toast.error("Mobile number must be 10 digits (Indian format).");
  //       return;
  //     }

  //     // 📧 Validate Gmail address
  //     const personalEmailPattern =
  //       /^(?!.*\.\.)(?!\.)[a-zA-Z0-9._]{2,}(?<!\.)@gmail\.com$/;
  //     if (!personalEmailPattern.test(updatedData.personalEmail)) {
  //       toast.error("Invalid Gmail format.");
  //       return;
  //     }

  //     // 🔤 Text-only fields validation
  //     const textOnly = /^[A-Za-z\s]{1,25}$/;
  //     const invalidTextFields = ["firstName", "lastName", "designation", "departmentName"]
  //       .filter((field) => !textOnly.test(updatedData[field]));
  //     if (invalidTextFields.length > 0) {
  //       toast.error("Name, Designation, and Department must contain only letters (max 25 chars).");
  //       return;
  //     }

  //     // 🎂 Age validation (must be ≥18)
  //     const birthDate = new Date(updatedData.dateOfBirth);
  //     const today = new Date();
  //     const minDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
  //     if (birthDate > minDate) {
  //       toast.error("Candidate must be at least 18 years old.");
  //       return;
  //     }

  //     // 📊 Leave validation
  //     const maxLeave = 50;
  //     if (
  //       updatedData.totalAllocatedSickLeave > maxLeave ||
  //       updatedData.totalAllocatedCasualLeave > maxLeave ||
  //       updatedData.totalAllocatedEarnedLeave > maxLeave
  //     ) {
  //       toast.error("Allocated leaves cannot exceed 50 per category.");
  //       return;
  //     }

  //     const token = localStorage.getItem("token");

  //     // 🟡 Get only changed fields
  //     const changedPayload = getChangedFields(selectedEmployee, updatedData);

  //     // 🟢 Add mobile number and country code ONLY if changed
  //     const originalCleanMobile = selectedEmployee.mobileNumber?.replace(/\D/g, '') || '';
  //     if (cleanMobile !== originalCleanMobile) {
  //       changedPayload.mobileNumber = cleanMobile;
  //       changedPayload.countryCode = "+91";
  //     }

  //     // 🟢 Ensure role is array if changed
  //     if (changedPayload.role) {
  //       changedPayload.role = [changedPayload.role];
  //     }

  //     console.log("📦 Final PATCH payload:", changedPayload);

  //     // ✅ Stop if nothing changed
  //     if (Object.keys(changedPayload).length === 0) {
  //       toast.info("No changes detected.");
  //       return;
  //     }

  //     // 🔗 API call
  //     const response = await axios.patch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/${selectedEmployee.empId}`,
  //       changedPayload,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("✅ Update success:", response.data);
  //     toast.success("Employee updated successfully!");
  //     setShowEditModal(false);
  //     featchEmployeeData(); // Refresh list
  //   } catch (error) {
  //     console.error("❌ Error updating employee:", error);
  //     toast.error("Failed to update employee.");
  //   }
  // };
  const handleSave = async (updatedData) => {
    try {
      console.log("Updated data:", updatedData);

      // 🔍 Mobile number validation
      const cleanMobile = updatedData.mobileNumber?.replace(/\D/g, "") || "";

      const mobilePattern = /^[0-9]{10}$/;

      if (!mobilePattern.test(cleanMobile)) {
        toast.error("Mobile number must be 10 digits.");
        return;
      }

      // 📧 Gmail validation
      const personalEmailPattern =
        /^(?!.*\.\.)(?!\.)[a-zA-Z0-9._]{2,}(?<!\.)@gmail\.com$/;

      if (!personalEmailPattern.test(updatedData.personalEmail)) {
        toast.error("Invalid Gmail format.");
        return;
      }

      // 🔤 Text validation
      const textOnly = /^[A-Za-z\s]{1,25}$/;

      const invalidTextFields = [
        "firstName",
        "lastName",
        "designation",
        "departmentName",
      ].filter((field) => !textOnly.test(updatedData[field] || ""));

      if (invalidTextFields.length > 0) {
        toast.error(
          "Name, Designation, and Department must contain only letters.",
        );
        return;
      }

      // 🎂 Age validation
      const birthDate = new Date(updatedData.dateOfBirth);

      const today = new Date();

      const minDate = new Date(
        today.getFullYear() - 18,
        today.getMonth(),
        today.getDate(),
      );

      if (birthDate > minDate) {
        toast.error("Candidate must be at least 18 years old.");
        return;
      }

      // 📊 Leave validation
      const maxLeave = 50;

      if (
        updatedData.totalAllocatedSickLeave > maxLeave ||
        updatedData.totalAllocatedCasualLeave > maxLeave ||
        updatedData.totalAllocatedEarnedLeave > maxLeave
      ) {
        toast.error("Allocated leaves cannot exceed 50 per category.");
        return;
      }

      const token = localStorage.getItem("token");

      // ✅ FULL PAYLOAD
      const payload = {
        // ...selectedEmployee,
        ...updatedData,

        // Ensure mobile formatting
        mobileNumber: cleanMobile,

        // Ensure country code exists
        countryCode: "+91",

        // Ensure role is array
        role: Array.isArray(updatedData.role)
          ? updatedData.role
          : [updatedData.role],
      };

      
      // 🔗 API CALL
      const response = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/${selectedEmployee.empId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      console.log("✅ Update success:", response.data);

      toast.success("Employee updated successfully!");

      setShowEditModal(false);

      featchEmployeeData();
    } catch (error) {
      console.error("❌ Error updating employee:", error);

      toast.error("Failed to update employee.");
    }
  };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
    setPageNumber(0);
  };

  // const filteredEmployees = (employee || []).filter((emp) => {
  //   const fullName = `${emp.firstName ?? ""} ${emp.middleName ?? ""} ${emp.lastName ?? ""}`.trim();

  //   return fullName.toLowerCase().includes(searchQuery.toLowerCase());
  // });

  // const filteredTotalElements = filteredEmployees.length;
  // const filteredTotalPages = Math.ceil(filteredTotalElements / pageSize);

  const filteredEmployees = (employee || []).filter((emp) => {
    const fullName =
      `${emp.firstName ?? ""} ${emp.middleName ?? ""} ${emp.lastName ?? ""}`.trim();

    return fullName.toLowerCase().includes(searchQuery.toLowerCase());
  });
  const noResults = !loading && filteredEmployees.length === 0;
  const filteredTotalElements = filteredEmployees.length;
  const filteredTotalPages = Math.ceil(filteredTotalElements / pageSize);

  const paginatedEmployees = filteredEmployees.slice(
    pageNumber * pageSize,
    (pageNumber + 1) * pageSize,
  );
  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleViewEmployee = (empId) => {
    navigate("/employee-dashboard", { state: { empId } });
  };
  const isSearching = searchQuery.trim() !== "";
  const disableNext = pageNumber >= filteredTotalPages - 1;
  // const disableNext = isSearching
  //   ? filteredEmployees.length < pageSize
  //   : pageNumber >= totalPages - 1;
  return (
    <Layout>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="backgound-main-content">
        <div className="timesheet-header">
          {isMobile ? (
            <div className="">
              <div className="header-mob-title">
                <h2>Employee Manager</h2>
                <button
                  className="add-emp-mob-button"
                  onClick={handleOpenModal}
                >
                  <div className="add-emp-icon-mob-container">
                    <Icon
                      icon="material-symbols:person-add-outline-rounded"
                      width="18"
                      height="18"
                      style={{ color: "#00AFEF" }}
                    />
                  </div>
                </button>
              </div>

              <div className="timesheet-controls">
                <div className="search-bar">
                  <input
                    type="text"
                    className="border-none"
                    placeholder="Search employee name"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                  <Icon
                    icon="iconamoon:search"
                    width="20"
                    height="20"
                    color="rgba(0, 175, 239, 1)"
                  />
                </div>
              </div>
              <div className="employee-card-list">
                {loading ? (
                  // 🔹 Show 6 skeleton cards while loading
                  Array.from({ length: 6 }).map((_, index) => (
                    <div className="employee-card" key={index}>
                      <div className="emp-head">
                        <p className="emp-id">
                          <Skeleton width={50} height={16} />
                        </p>
                        <div className="card-actions-menu">
                          <Skeleton circle width={20} height={20} />
                        </div>
                      </div>
                      <div className="card-main">
                        <Skeleton
                          circle
                          width={60}
                          height={60}
                          className="card-avatar"
                        />
                        <div className="card-info">
                          <h4 className="emp-name">
                            <Skeleton width={120} />
                          </h4>
                          <p className="emp-email">
                            <Skeleton width={160} />
                          </p>
                          <p className="emp-contact">
                            <Skeleton width={100} />
                          </p>
                          <p className="emp-department">
                            <Skeleton width={80} />
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : noResults ? (
                  <div className="text-center py-4">
                    <p
                      style={{
                        color: "#999",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                    >
                      No results found
                    </p>
                  </div>
                ) : (
                  paginatedEmployees.map((emp, index) => {
                    const fullName = `${emp.firstName ?? ""} ${
                      emp.middleName ?? ""
                    } ${emp.lastName ?? ""}`.trim();
                    const avatar = emp.profilePhotoUrl || "";
                    const empId = emp.empId ?? "-";
                    const officeEmail = emp.officeEmail ?? "-";
                    const mobile = emp.mobileNumber ?? "-";
                    const department = emp.departmentName ?? "-";

                    return (
                      <div className="employee-card" key={index}>
                        <div className="emp-head">
                          <p className="emp-id">{empId}</p>
                          <div className="card-actions-menu">
                            <Icon
                              icon="ph:dots-three-vertical-bold"
                              className="menu-toggle"
                              onClick={() => toggleMenu(emp.empId)}
                            />
                            {activeDropdown === emp.empId && (
                              <div className="menu-dropdown">
                                <span
                                  onClick={() => handleViewEmployee(emp.empId)}
                                >
                                  👁️ View
                                </span>
                                <span onClick={() => handleEditClick(emp)}>
                                  ✏️ Edit
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="card-main">
                          {avatar ? (
                            <img
                              src={avatar}
                              alt={fullName}
                              className="card-avatar"
                            />
                          ) : (
                            <div className="card-avatar placeholder">
                              <Icon icon="proicons:person" className="fs-5" />
                            </div>
                          )}
                          <div className="card-info">
                            <h4 className="emp-name">
                              {capitalizeWords(fullName)}
                            </h4>
                            <p className="emp-email">{officeEmail}</p>
                            <p className="emp-contact">{mobile}</p>
                            <p className="emp-department">
                              {capitalizeWords(department)}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
              {!noResults && (
                <div className="pagination-controls">
                  <button
                    type="button"
                    className="pagination-btn pagination-prev"
                    disabled={pageNumber <= 0 || loading}
                    onClick={handlePrevPage}
                  >
                    <Icon
                      icon="material-symbols:chevron-left-rounded"
                      width="18"
                      height="18"
                    />
                    Previous
                  </button>
                  <span className="pagination-info">
                    Page {pageNumber + 1} of {filteredTotalPages}
                    {" • "}
                    {filteredTotalElements} records
                  </span>
                  <button
                    type="button"
                    className="pagination-btn pagination-next"
                    disabled={pageNumber >= filteredTotalPages - 1 || loading}
                    onClick={handleNextPage}
                  >
                    Next
                    <Icon
                      icon="material-symbols:chevron-right-rounded"
                      width="18"
                      height="18"
                    />
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="">
              <div className="header-title">
                <h2>Employee Manager</h2>
                <button
                  style={{
                    ...btnfont,
                    ...Newbtn,
                  }}
                  onClick={handleOpenModal}
                >
                  <Icon
                    icon="material-symbols:add-rounded"
                    width="18"
                    height="18"
                  />
                  New Employee
                </button>
              </div>

              <div className="timesheet-controls">
                <div className="search-bar">
                  <input
                    type="text"
                    className="border-none"
                    placeholder="Search employee name"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                  <Icon
                    icon="iconamoon:search"
                    width="20"
                    height="20"
                    color="rgba(0, 175, 239, 1)"
                  />
                </div>
              </div>
              <div className="timesheet-table">
                <table className="employee-table">
                  <thead>
                    <tr>
                      <th style={LighterBold}>ID</th>
                      <th style={LighterBold}>Employee Name</th>
                      <th style={LighterBold}>Email Id</th>
                      <th style={LighterBold}>Contact Number</th>
                      <th style={LighterBold}>Department</th>
                      <th style={LighterBold}>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      // 🔹 Skeleton rows while loading
                      Array.from({ length: 5 }).map((_, index) => (
                        <tr key={index}>
                          <td>
                            <Skeleton width={40} />
                          </td>
                          <td className="employee-info d-flex align-items-center gap-2">
                            <Skeleton circle width={36} height={36} />
                            <Skeleton width={100} />
                          </td>
                          <td>
                            <Skeleton width={120} />
                          </td>
                          <td>
                            <Skeleton width={100} />
                          </td>
                          <td>
                            <Skeleton width={80} />
                          </td>
                          <td className="d-flex gap-3">
                            <Skeleton width={20} height={20} circle />
                            <Skeleton width={20} height={20} circle />
                          </td>
                        </tr>
                      ))
                    ) : noResults ? (
                      <tr>
                        <td colSpan="6" className="text-center py-4">
                          <p
                            style={{
                              color: "#999",
                              fontSize: "16px",
                              fontWeight: "500",
                              marginBottom: "0px",
                            }}
                          >
                            No results found
                          </p>
                        </td>
                      </tr>
                    ) : (
                      paginatedEmployees.map((emp, index) => {
                        const fullName = `${emp.firstName ?? ""} ${
                          emp.middleName ?? ""
                        } ${emp.lastName ?? ""}`.trim();
                        const avatar = emp.profilePhotoUrl || ""; // Show placeholder if null
                        const officeEmail = emp.officeEmail ?? "-";
                        const mobile = emp.mobileNumber ?? "-";
                        const department = emp.departmentName ?? "-";
                        const empId = emp.empId ?? " - ";

                        return (
                          <tr key={index}>
                            <td style={Lightly}>{empId}</td>
                            <td className="employee-info">
                              {avatar ? (
                                <img
                                  src={avatar}
                                  alt={fullName}
                                  className="rounded-circle"
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  className="rounded-circle d-flex justify-content-center align-items-center"
                                  style={{
                                    width: "36px",
                                    height: "36px",
                                    fontSize: "12px",
                                    color: "#999",
                                    backgroundColor: "#F0F0F0",
                                    border: "1px solid #F0F0F0 ",
                                  }}
                                >
                                  <Icon
                                    icon="proicons:person"
                                    className="fs-5 "
                                    style={{}}
                                  />
                                </div>
                              )}
                              <span style={DarkBold}>
                                {capitalizeWords(fullName)}
                              </span>
                            </td>
                            <td style={Lightly}>{officeEmail}</td>
                            <td style={Lightly}>{mobile}</td>
                            <td style={Lightly}>
                              {capitalizeWords(department)}
                            </td>
                            {/* <td className="d-flex gap-3">
          <Icon icon="hugeicons:view" className="eye" />
          <Icon icon="mdi:edit" className="pen" />
          <Icon icon="material-symbols:delete-outline" color="red" />
        </td> */}
                            <td className="d-flex gap-3">
                              <Icon
                                icon="hugeicons:view"
                                style={{
                                  color: "#00AFEF",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleViewEmployee(emp.empId)}
                              />
                              <Icon
                                icon="mdi:edit"
                                style={{
                                  color: "#00AFEF",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleEditClick(emp)}
                              />
                              {/* <Icon
                          icon="material-symbols:delete-outline"
                          style={{
                            color: "#DD0000",
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                        /> */}
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
              {!noResults && (
                <div className="pagination-controls">
                  <button
                    type="button"
                    className="pagination-btn pagination-prev"
                    disabled={pageNumber <= 0 || loading}
                    onClick={handlePrevPage}
                  >
                    <Icon
                      icon="material-symbols:chevron-left-rounded"
                      width="18"
                      height="18"
                    />
                    Previous
                  </button>
                  <span className="pagination-info">
                    Page {pageNumber + 1} of {filteredTotalPages}
                    {" • "}
                    {filteredTotalElements} records
                  </span>
                  <button
                    type="button"
                    className="pagination-btn pagination-next"
                    //  disabled={pageNumber >= totalPages - 1 || loading}
                    disabled={disableNext || loading}
                    onClick={handleNextPage}
                  >
                    Next
                    <Icon
                      icon="material-symbols:chevron-right-rounded"
                      width="18"
                      height="18"
                    />
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
        {/* Show Modal */}
        {showModal && (
          <AddEmployeeModel
            onClose={handleCloseModal}
            onEmployeeAdded={() => {
              featchEmployeeData(); // Refresh data after new employee is added
              setShowModal(false); // Close modal
            }}
          />
        )}
        {showEditModal && selectedEmployee && (
          <EditModel
            employee={selectedEmployee}
            onClose={handleClose}
            onSave={handleSave}
          />
        )}
      </div>
    </Layout>
  );
};

export default EmployeeManagement;
